import { render, staticRenderFns } from "./TaskDocuments.vue?vue&type=template&id=5d24a3da&"
import script from "./TaskDocuments.vue?vue&type=script&lang=js&"
export * from "./TaskDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TaskDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports